@if (data$ | async; as data) {
  <cv-information-entity label="Answering Agent">
    <ng-template cvTemplate="content">
      @if (isAgentEditMode) {
        <form class="agent-field__form" [formGroup]="form">
          @if (data.agentsState.loading || data.agentsState.updating) {
            <cv-loader [isOverlay]="false"></cv-loader>
          } @else {
            <p-dropdown
              emptyFilterMessage="Agent not found."
              optionLabel="fullName"
              placeholder="Unknown Agent"
              formControlName="agent"
              [group]="true"
              [filter]="true"
              [options]="
                data.agentsState.data
                  | agentGroups: data.conversationDetails.data?.siteName : data.conversationDetails.data?.accountName
              "
            >
              <ng-template let-group pTemplate="group">
                @if (group.label) {
                  <span>{{ group.label }}</span>
                }
              </ng-template>

              <ng-template pTemplate="item" let-item>
                @if (item.isCallCenterAgent) {
                  <div class="agent-field__call-center-agent">
                    @if (item.agentId === UNKNOWN_AGENT_ID) {
                      <img src="assets/icons/question-box.svg" alt="question box" width="13" height="14" />
                    } @else {
                      <img src="assets/icons/headset.svg" alt="headset" width="13" height="14" />
                    }
                    <span>{{ item.fullName }}</span>
                  </div>
                } @else {
                  <span>{{ item.fullName }}</span>
                }
              </ng-template>
            </p-dropdown>

            <div class="agent-field__controls">
              <div class="agent-field__control" aria-hidden="true" (click)="onSubmit()">
                <img src="assets/icons/save-icon.svg" alt="save-icon" width="15" height="16" />
              </div>
              <div class="agent-field__control" aria-hidden="true" (click)="isAgentEditMode = false">
                <img src="assets/icons/cancel-icon.svg" alt="cancel-icon" width="13" height="13" />
              </div>
            </div>
          }
        </form>
      } @else {
        <div class="agent-field__label">
          @if (
            data.conversationDetails.data?.agentFirstName | fullName: data.conversationDetails.data?.agentLastName;
            as agent
          ) {
            <span>{{ agent }}</span>
          }
          <div aria-hidden="true" class="agent-field__edit-button agent-field__control" (click)="editAgent()">
            <img alt="Edit Agent Icon" src="/assets/icons/edit.svg" />
          </div>
        </div>
      }
    </ng-template>
  </cv-information-entity>
}
